export default __webpack_public_path__ + "static/media/requirement-image.a70c67e8.png";